import KendoPivotGrid from './KendoPivotGrid'
import KendoPivotConfigurator from './KendoPivotConfigurator'
import KendoPivotGridInstaller from './kendo-pivotgrid-installer'

export { KendoPivotGrid, KendoPivotGrid as PivotGrid, KendoPivotConfigurator, KendoPivotConfigurator as PivotConfigurator, KendoPivotGridInstaller, KendoPivotGridInstaller as PivotGridInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/index.js